// Pure (tiptap-free) PornHub URL helpers, extracted from PornHub.ts so the main
// barrel can re-export them without dragging @tiptap/core into the eager bundle.
// The tiptap extension definition (`PornHub`) stays in PornHub.ts.

export const PORN_HUB_REGEX_GLOBAL = /https?:\/\/(?:www\.)?pornhub\.com\/view_video\.php\?[^\s]*viewkey=[a-zA-Z0-9]+[^\s]*/gi

export type PornHubUrlMetadata = {
  normalizedUrl: string
  viewKey: string
  passthroughParams: URLSearchParams
}

export function getPornHubUrlMetadata(url: string): PornHubUrlMetadata | null {
  try {
    const parsedUrl = new URL(url.trim())
    if (!['pornhub.com', 'www.pornhub.com'].includes(parsedUrl.hostname) || parsedUrl.pathname !== '/view_video.php') {
      return null
    }

    const viewKey = parsedUrl.searchParams.get('viewkey')
    if (!viewKey) {
      return null
    }

    const passthroughParams = new URLSearchParams(parsedUrl.search)
    passthroughParams.delete('viewkey')

    return {
      normalizedUrl: parsedUrl.toString(),
      viewKey,
      passthroughParams,
    }
  } catch {
    return null
  }
}

// Returns the provider embed URL when `url` is a recognized PornHub video URL, otherwise `null`.
// The no-match branch must NOT fall back to the raw input: the render nodes feed this straight into an
// iframe `src`, so returning the unvalidated url reintroduces the stored-XSS scheme it is meant to gate.
export function getEmbedUrlFromPornHubUrl(url: string): string | null {
  const metadata = getPornHubUrlMetadata(url)
  if (metadata) {
    const embedUrl = new URL(`https://www.pornhub.com/embed/${metadata.viewKey}`)
    for (const [key, value] of metadata.passthroughParams.entries()) {
      embedUrl.searchParams.append(key, value)
    }

    return embedUrl.toString()
  }

  return null
}

export function isValidPornHubUrl(url: string) {
  return getPornHubUrlMetadata(url) !== null
}
